import warn from './warn';

export default warn;

export const deprecateProp = (componentName, oldProp, newProp, removeDate) => {
  warn(
    `${componentName}: ${oldProp} is deprecated and will be removed at ${removeDate.toDateString()}, use ${newProp} instead`
  );
};

export const deprecateCssClass = (componentName, condition, removeDate) => {
  if (condition) {
    deprecateProp(componentName, 'cssClass', 'className', removeDate);
  }
};

export const deprecateComponent = (componentName, newComponent, removeDate) => {
  const timeframe = removeDate ? `at ${removeDate.toDateString()}` : 'in the future';
  if (newComponent) {
    warn(
      `${componentName} is deprecated and will be removed ${timeframe}, use ${newComponent} instead.`
    );
  } else {
    warn(`${componentName} is deprecated and will be removed ${timeframe}.`);
  }
};
